var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45205 6.62727L5.12329 5.86364C4.06849 4.62273 2.53425 3.95455 1 3.95455V4.90909C2.24658 4.90909 3.49315 5.48182 4.35616 6.43636L4.45205 6.62727ZM11.6438 11.1136C10.4932 11.1136 9.43836 10.6364 8.57534 9.87273L8 10.6364C8.9589 11.5909 10.3014 12.0682 11.6438 12.0682V13.5L15 11.5909L11.6438 9.68182V11.1136ZM11.6438 5.38636V6.81818L15 4.90909L11.6438 3V4.43182C10.1096 4.43182 8.57534 5.1 7.61644 6.34091L4.35616 10.0636C3.49315 11.0182 2.24658 11.5909 1 11.5909V12.5455C2.53425 12.5455 4.06849 11.8773 5.0274 10.6364L8.28767 6.91364C9.15068 5.95909 10.3973 5.38636 11.6438 5.38636Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.f489a368250a9bb14ed82efbc80e32a7.svg";
export { ForwardRef as ReactComponent };